<template>
    <div>
        <Button type="primary" @click="modal1 = true" v-hasPermission="['configurationManagement:schedules:add_schedule']">{{ $t('configuration_management.schedules.addSchedule') }}</Button>
        <Modal v-model="modal1" :title="$t('configuration_management.schedules.addSchedule')" @on-ok="schedulesSubmit('schedulesForm')" @on-cancel="schedulesReset('schedulesForm')" :loading="loading" :mask-closable="false"
               :okText="$t('alarms.common.add')" :cancelText="$t('alarms.common.cancel')">
            <Form ref="schedulesForm" :model="schedulesForm" :label-width="100" :rules="ruleValidate">
                <!-- 名称 -->
                <FormItem :label="$t('configuration_management.schedules.name')" prop="name">
                    <Input v-model="schedulesForm.name" placeholder="Enter something..." style="width:300px;"></Input>
                </FormItem>

                <!-- 重复 -->
                <Row>
                    <Col span="11" style="z-index:100;">
                        <FormItem :label="$t('configuration_management.schedules.repetition')" prop="frequencyNum">
                            <InputNumber :max="100" :min="1" v-model="schedulesForm.frequencyNum"></InputNumber>
                        </FormItem>
                    </Col>
                    <Col span="12" style="z-index:50;margin-left: -100px;">
                        <FormItem prop="frequencyUnit">
                            <Select v-model="schedulesForm.frequencyUnit" placeholder="">
                                <Option value="0">{{ $t('configuration_management.schedules.minute') }}</Option>
                                <Option value="1">{{ $t('configuration_management.schedules.hour') }}</Option>
                                <Option value="2">{{ $t('configuration_management.schedules.day') }}</Option>
                                <Option value="3">{{ $t('configuration_management.schedules.week') }}</Option>
                                <Option value="4">{{ $t('configuration_management.schedules.month') }}</Option>
                            </Select>
                        </FormItem>
                    </Col>
                </Row>

                <!-- 开始时间 -->
                <FormItem :label="$t('configuration_management.schedules.start')" prop="scheduleStartTime">
                    <DatePicker type="datetime" placeholder="Select date and time" style="width: 200px" v-model="schedulesForm.scheduleStartTime" :options="startTimeOptions" ></DatePicker>
                </FormItem>

                <!-- 结束时间 -->
                <FormItem :label="$t('configuration_management.schedules.end')" prop="scheduleEndTime">
                    <!-- <a href="#">从不(点击修改)</a> -->
                    <DatePicker type="datetime" placeholder="Select date and time" style="width: 200px" v-model="schedulesForm.scheduleEndTime" :options="endTimeOptions" ></DatePicker>
                </FormItem>

                <!-- 启用于 -->
                <FormItem :label="$t('configuration_management.schedules.startFor')" prop="enableWeekdays">
                    <CheckboxGroup v-model="schedulesForm.enableWeekdays">
                        <Checkbox label="1">{{ $t('configuration_management.schedules.Monday') }}</Checkbox>
                        <Checkbox label="2">{{ $t('configuration_management.schedules.Tuesday') }}</Checkbox>
                        <Checkbox label="3">{{ $t('configuration_management.schedules.Wednesday') }}</Checkbox>
                        <Checkbox label="4">{{ $t('configuration_management.schedules.Thursday') }}</Checkbox>
                        <Checkbox label="5">{{ $t('configuration_management.schedules.Friday') }}</Checkbox>
                        <Checkbox label="6">{{ $t('configuration_management.schedules.Saturday') }}</Checkbox>
                        <Checkbox label="0">{{ $t('configuration_management.schedules.Sunday') }}</Checkbox>
                    </CheckboxGroup>
                </FormItem>

                <!-- 描述 -->
                <FormItem :label="$t('configuration_management.schedules.describe')" prop="describe">
                    <Input v-model="schedulesForm.describe" type="textarea" :autosize="{minRows: 2,maxRows: 5}" placeholder="Enter something..." style="width:300px;"></Input>
                </FormItem>

            </Form>
        </Modal>
    </div>
</template>
<script>
    import {getCookie} from '../../../../utils/cookieUtil.js'
    import TableSchedules from '../schedules/TableSchedules.vue'
    var tableSchedules = TableSchedules;
    export default {
        name: 'AddSchedules',
        data () {
            return {
                schedulesForm: {
                    name: '',
                    frequencyNum: 1,
                    frequencyUnit: '',
                    scheduleStartTime: '',
                    scheduleEndTime: '',
                    enableWeekdays: [],
                    describe: ''
                },
                startTimeOptions: {}, //开始日期设置
                endTimeOptions: {}, //结束日期设置
                modal1: false,
                loading: true,
                value1: '',
                value2: '',
                ruleValidate: {
                    name: [
                        { required: true, message: this.$t('configuration_management.schedules.nameRequired'), trigger: 'blur'},
                        { type: 'string', message: this.$t('configuration_management.schedules.namePattern'), pattern:'^.{8,20}$', trigger: 'blur'}
                    ],
                    frequencyNum: [
                        { required: true, message: this.$t('configuration_management.schedules.frequencyNumRequired'), trigger: 'blur',type: 'number'}
                    ],
                    frequencyUnit: [
                        { required: true, message: this.$t('configuration_management.schedules.frequencyUnitRequired'), trigger: 'change'}
                    ],
                    scheduleStartTime: [
                        { required: true, message: this.$t('configuration_management.common.pleaseSelectStartTime'), trigger: 'blur',type: 'date'}
                    ],
                    scheduleEndTime: [
                        { required: true, message: this.$t('configuration_management.common.pleaseSelectEndTime'), trigger: 'blur',type: 'date'}
                    ],
                    enableWeekdays: [
                         { required: true, type: 'array', min: 1, message: this.$t('configuration_management.schedules.atLeastOne'), trigger: 'change' },
                         { type: 'array', max: 7, message: this.$t('configuration_management.schedules.atMostSeven'), trigger: 'change' }
                    ],
                    describe: [
                        { required: false, message: this.$t('configuration_management.schedules.pleaseEnterDescribe'), trigger: 'blur'},
                        { type: 'string', max: 100, message: this.$t('configuration_management.common.max100Characters'), trigger: 'blur' }
                    ]
                },
                startTimeOptions: {
                    disabledDate (date) {
                        return date && date.valueOf() < Date.now() - 86400000;
                    }
                },
                endTimeOptions: {
                    disabledDate (date) {
                        return date && date.valueOf() < Date.now() - 86400000;
                    }
                }
            }
        },
        methods: {
            schedulesSubmit: function(name){
                this.$refs[name].validate(valid => {
                    if(valid){
                        // 创建日程
                        this.$api.scheduleManagement.createSchedule({
                            "name": this.schedulesForm.name,
                            "frequencyNum": this.schedulesForm.frequencyNum,
                            "frequencyUnit": this.schedulesForm.frequencyUnit,
                            "scheduleStartTime": this.schedulesForm.scheduleStartTime,
                            "scheduleEndTime": this.schedulesForm.scheduleEndTime,
                            "enableWeekdays": JSON.stringify(this.schedulesForm.enableWeekdays),
                            "description": this.schedulesForm.describe
                        })
                        .then(res => {
                            this.data = res.data;
                            setTimeout(() => {
                                tableSchedules.methods.showAll();
                                this.$refs[name].resetFields();
                                this.loading = false;
                                this.$nextTick(() => {
                                    this.loading = true;
                                });
                                this.$Message.success(this.$t('common.addSuccess'));
                                this.modal1 = false;
                            },1000);
                        })
                    }else{
                        //解决iview 表单验证，验证提示error完成验证后，"确定"按钮一直转圈，点击不起作用问题
                        this.loading = false;
                        setTimeout(() => {
                            this.loading = true
                        }, 0)
                        this.$Message.error(this.$t('common.addFail'));
                    }
                });
            },
            schedulesReset: function(name){
                this.$refs[name].resetFields();
            }
        }
    }
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/configuration/configuration_management/schedules/AddSchedules.vue